// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a8f5b2eb","239":"76cee198","455":"38f7c911"}[chunkId] + ".chunk.js";
};